import React, { useEffect, useState } from 'react';
import { CountDownTimerProps } from './OffersMBEHero.types';
import { calculateTimeLeft } from '../../utils/OfferUtils';
import { StyledOffersMBEHero } from './OffersMBEHero.styles';

export const CountDownTimer: React.FC<CountDownTimerProps> = props => {
  const { startDate, isAuthorMode, model, onCountdownComplete } = props;
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(startDate, isAuthorMode));

  useEffect(() => {
    if (isAuthorMode) return;

    const updateTime = () => {
      const newTimeLeft = calculateTimeLeft(startDate, isAuthorMode);
      setTimeLeft(newTimeLeft);

      // Check if countdown has reached zero
      if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        onCountdownComplete?.();
      }
    };

    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, [startDate, isAuthorMode, onCountdownComplete]);

  const timeLabels = [model.daysLabel, model.hoursLabel, model.minutesLabel, model.secondsLabel];
  const timeEntries = Object.entries(timeLeft);

  return (
    <StyledOffersMBEHero>
      <div className="countdownWrapper">
        {timeEntries.map(([key, value], index) => (
          <React.Fragment key={key}>
            {index > 0 && <div className="separator" />} {/* Separator between tiles */}
            <div className="countdownUnit">
              <div className="countdownTile">
                <span className="countdownNumber">
                  {value !== undefined ? value.toString().padStart(2, '0') : '00'}
                </span>
              </div>
              <div className="countdownLabelsWrapper">
                <span className="countdownLabel">{timeLabels[index]}</span>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </StyledOffersMBEHero>
  );
};
export default CountDownTimer;
